import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const CompanyAddressRecord = Record({
  address: '',
  postalCode: '',
});

export default class CompanyAddress extends CompanyAddressRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new CompanyAddress(hydrated);
  }
}
